<template>
  <div class="edit">
    <el-dialog title="编辑"
               :visible.sync="dialogVisible"
               width="996px"
               :before-close="handleClose">
      <el-form :model="ruleForm"
               ref="ruleForm"
               label-width="120px"
               class="demo-ruleForm">
        <el-form-item label="库存:"
                      prop="merchandise_inventory"
                      :rules="rules.merchandise_inventory">
                      <span>{{ruleForm.merchandise_inventory}}</span>
        </el-form-item>
        <el-form-item label="参与最大销量:"
                      prop="rules.max_sales_num"
                      :rules="rules.max_sales_num">
                      <el-input v-model="ruleForm.max_sales_num"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    size="small"
                    style="width: 200px"
                   >
          
          </el-input>
        <!--   <el-input-number v-model="ruleForm.max_sales_num"
                           style="width: 200px"
                           :min="0"
                           :max="Number(ruleForm.max_sales_num)"></el-input-number> -->
        </el-form-item>
        <el-form-item label="拼团价:"
                      prop="price"
                      v-if="activeName == 'activity_team'"
                      :rules="rules.price">
          <el-input v-model="ruleForm.price"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    size="small"
                    style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="活动价:"
                      prop="price"
                      v-if="activeName == 'activity_link'"
                      :rules="rules.price">
          <el-input v-model="ruleForm.price"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    size="small"
                    style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="团长价:"
                      prop="leader_price"
                      v-if="activeName == 'activity_team'">
          <el-input v-model="ruleForm.leader_price"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    size="small"
                    style="width: 200px"
                    :disabled="ruleForm.is_open_leader_price == 2">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="活动比例:"
                      v-if="activeName != 'activity_team'">
          <el-input v-model="ruleForm.reward_share"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    size="small"
                    style="width: 200px"
                    :disabled="Number(ruleForm.reward_share) == '' && Number(ruleForm.reward_cash) != ''">
            <template slot="append">%</template>
          </el-input>
          或
          <el-input v-model="ruleForm.reward_cash"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    size="small"
                    style="width: 200px"
                    :disabled="Number(ruleForm.reward_cash) == '' && Number(ruleForm.reward_share) != ''">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      dialogVisible: false,
      ruleForm: {
        merchandise_inventory: "",
        price: "",
        leader_price: "",
        reward_share: "",
        reward_cash: "",
        max_sales_num:'',
        shop_id:''
      },
      rules: {
        max_sales_num: [{ required: true, message: "请输入参与活动库存", trigger: "blur" }],
        price: [{ required: true, message: "请输入拼团价", trigger: "blur" }],
      },
    };
  },
  props: {
    activeName: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    ...mapActions({
      productEdit: "activity/productEdit",
    }),
    submit () {
      if (this.ruleForm.reward_share == "" && this.ruleForm.reward_cash == "") {
        this.$message.warning("返现比例或金额不能为空！");
      }
      let activityProductData;
      switch (this.activeName) {
        case "activity_team":
          activityProductData = {
            id: this.ruleForm.activity_goods_id,
            product_id: this.ruleForm.product_id,                    // 商品的spuid
            product_sku_id: this.ruleForm.product_sku_id,              // 商品的skuid
            max_sales_num: this.ruleForm.max_sales_num,
            img_url:this.ruleForm.img_url   ,             // sku图片
           // merchandise_inventory: this.ruleForm.merchandise_inventory, // 参加活动的库存
            price: this.ruleForm.price, // 拼团价
          };
          if (this.ruleForm.is_open_leader_price == 1) {
            activityProductData.leader_price = this.ruleForm.leader_price; // 团长价
          }
          break;
        case "activity_share":
          activityProductData = {
            id: this.ruleForm.activity_goods_id,
            product_id: this.ruleForm.product_id,                    // 商品的spuid
            product_sku_id: this.ruleForm.product_sku_id,              // 商品的skuid
            max_sales_num: this.ruleForm.max_sales_num,
          //  merchandise_inventory: this.ruleForm.merchandise_inventory, // 参加活动的库存
            reward_share: this.ruleForm.reward_share, // 奖励份额：比例
            reward_cash: this.ruleForm.reward_cash, // 奖励金额：现金
              img_url:this.ruleForm.img_url                // sku图片
          };
          break;
        case "activity_link":
          activityProductData = {
            id: this.ruleForm.activity_goods_id,
            product_id: this.ruleForm.product_id,                    // 商品的spuid
            product_sku_id: this.ruleForm.product_sku_id,              // 商品的skuid
            max_sales_num: this.ruleForm.max_sales_num,
  price: this.ruleForm.price, //活动价
         //   merchandise_inventory: this.ruleForm.merchandise_inventory, // 参加活动的库存
            reward_share: this.ruleForm.reward_share, // 奖励份额：比例
            reward_cash: this.ruleForm.reward_cash, // 奖励金额：现金
             img_url:this.ruleForm.img_url,                // sku图片
              /* shop_id:this.ruleForm..shop_id, */
          };


          break;
        default:
          break;
      }
      console.log(this.ruleForm, 'this.ruleForm')
      let goods = []
      goods.push(activityProductData)
      let params = {
        token: this.getToken,
        /*                 activity_name: this.activeName,
                        activityProductId: this.ruleForm.id, */
        activitys_mains_id: this.ruleForm.activity_id,
        type: this.activeName == 'activity_link' ? 1 : this.activeName == 'activity_team' ? 2 : 3,
        start_time: this.ruleForm.start_time,
        end_time: this.ruleForm.end_time,
        goods: goods,
      };

      this.productEdit(params).then(({ data }) => {
        if (data.code == 1) {
          this.$message.success("修改成功！");
          this.$emit("init");
          this.handleClose();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleClose () {
      this.dialogVisible = false;
      // this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  ::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
.el-form {
  height: 450px;
}
</style>
